import { useEffect, useState } from 'react';
import { navigate } from '@reach/router';
import { useSelector } from 'react-redux';
import isMobileDevice from 'utils/isMobileDevice';

const BADGE_SELECTOR = '.grecaptcha-badge';

const useGoogleRecaptchaBadge = () => {
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const recaptchaToken = useSelector(
    ({ session }) => session.meta.configs.google_recaptcha_site_key,
  );

  window.recaptchaLoaded = () => {
    setScriptLoaded(true);
  };

  useEffect(() => {
    const script = document.createElement('script');

    script.src = `https://www.google.com/recaptcha/api.js?render=${recaptchaToken}&onload=recaptchaLoaded`;
    script.async = true;
    script.defer = true;

    if (recaptchaToken) {
      document.body.appendChild(script);
    }

    return () => {
      if (recaptchaToken) {
        document.body.removeChild(script);
      }
    };
  }, [recaptchaToken]);

  const recaptchaEnabled = useSelector(({ groups, page, ui }) => {
    const isMobile = isMobileDevice();
    /** hack because we force mobile on certain pages */
    if (isMobile || page.name === 'funding' || page.name === 'launch') {
      const groupKeys = Object.keys(groups);
      const [firstGroupName] = groupKeys;
      return groups[ui.activeGroup || firstGroupName]?.recaptchaEnabled || false;
    }

    return page.recaptchaEnabled;
  });

  useEffect(() => {
    const badge = document.querySelector(BADGE_SELECTOR);
    if (badge && scriptLoaded) {
      badge.style.visibility = recaptchaEnabled ? 'visible' : 'hidden';
    } else if (scriptLoaded) {
      window.console.error('Recaptcha key is not valid. Please fix the configuration.');
      navigate('/oao/error');
    }
    return () => {
      if (badge && scriptLoaded) {
        badge.style.visibility = 'hidden';
      }
    };
  }, [recaptchaEnabled, scriptLoaded]);
};

export default useGoogleRecaptchaBadge;
